import { IResource, IResourceAction, IResourceSelectors, IResourceState } from '../generators/resource.types';
import { IMeetingSimple } from '../meeting-simple/meeting-simple.types';
import { IMeeting } from '../meeting/meeting.types';

export const BACKBURNUER = '-1';
export const FREE_ACTIVITY = 'free_activity';
export const KPI = 'scorecard';
export const ROCK_REVIEW = 'rock_review';
export const ACCOUNTABILITY_LIST = 'accountability_list';
export const ACCOUNTABILITY_BOARD = 'accountability_board';
export const EXTERNAL_URL = 'external_url';
export const TODO = 'to_do_list';
export const CONCLUSION = 'conclusion';

export const AGENDA_ITEM_TYPES = [BACKBURNUER, ROCK_REVIEW, TODO];

export interface IAgendaItem extends IResource {
  meetingId: string;
  title: string;
  description: string;
  keyName: string;
  functionName: string;
  color: string;
  sort: string;
  deleted: string;
  duration: string;
  checked: string;
  boardId?: string;
  boardListId?: string;
  embedUrl?: string;
}

export interface IAgenda extends IResource {
  title: string;
  description: string;
  keyName: string;
  functionName: string;
  color: string;
  sort: string;
  duration: string;
  checked: string;
}

export interface IAgendaCreate {
  title: string;
  description: string;
  keyName: string;
  functionName: string;
  color: string;
  sort: string;
  deleted: string;
  duration: string;
  checked: string;
}
export interface IAgendaUpdate {
  id?: IAgenda['id'];
  title: string;
  description: string;
  keyName: string;
  functionName: string;
  color: string;
  sort: string;
  deleted: string;
  duration: string;
  checked: string;
}

export interface IAgendaItemSearchParams {
  id?: IMeeting['id'];
}
export interface IAgendaItemsResponse {
  agendaItems: IAgendaItem[];
  meetingId: IMeetingSimple['id'];
}

export type IAgendaItemAction = IResourceAction<IAgendaItem>;
export type IAgendaItemState = IResourceState<IAgendaItem>;
export type IAgendaItemSelectors = IResourceSelectors<IAgendaItem>;
